export const Topics = [
  { name: 'Getting started', 
    children: [
      {name: 'Project', link: "project"},
      {name: 'Coordinate System', link: "coordinate"},
      {name: 'Bounding Box', link: "boundingbox"},
      {name: 'Wellbore', link: "wellbore"},
      {name: 'Geophone', link: "geophone"},
      {name: 'Perforator', link: "perforator"},
      {name: 'MicroSeismic Events', link: "seismicEvent"},
      {name: 'Formation', link: "formation"},
      {name: 'Histogram and Filter', link: "histogram"},
      {name: 'Navigation', link: "navigation"},
      {name: 'Object Info', link: "objectInfo"},
      {name: 'Measurement', link: "measurement"},
    ]
  },
  {
    name: 'Videos',
    children: [
      {name: 'Coordinate System', link: "coordinateVideo"},
      {name: 'Bounding Box', link: "boundingboxVideo"},
      {name: 'Wellbore', link: "wellboreVideo"},
      {name: 'Geophone', link: "geophoneVideo"},
      {name: 'Perforator', link: "perforatorVideo"},
      {name: 'MicroSeismic Events', link: "seismicEventVideo"},
      {name: 'Formation', link: "formationVideo"},
      {name: 'Histogram and Filter', link: "histogramVideo"},
      {name: 'Navigation', link: "navigationVideo"},
      {name: 'Object Info', link: "objectInfoVideo"},
      {name: 'Measurement', link: "measurementVideo"},
    ]
  },
];